// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBorderVerticleOutlinedSvg from "@fishx/icons-svg/es/asn/PBorderVerticleOutlined";
import FishxIcon from '../components/FishxIcon';

var PBorderVerticleOutlined = function PBorderVerticleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBorderVerticleOutlinedSvg
  }));
};

PBorderVerticleOutlined.displayName = 'PBorderVerticleOutlined';
export default React.forwardRef(PBorderVerticleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBorderVerticleOutlined.js
// module id = 3260
// module chunks = 0